<template>
  <div id="add_form" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-if="formParam.id!='' && formParam.id!=null">Edit Link</h5>
          <h5 class="modal-title" v-else>Add Link</h5>
          <!-- {{broadcastParam.broadcast_id}} -->
          <button
            ref="dismisModal"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>
                      Title:
                      <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formParam.button_title"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>
                          Button Text:
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="formParam.button_text"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Button Type</label>
                    <div class="col-lg-9">
                      <div class="form-check form-check-inline">
                        <input
                          class="form-check-input"
                          type="radio"
                          v-model="formParam.button_type"
                          id="call"
                          value="call"
                        />
                        <label class="form-check-label" for="call">Call</label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input
                          v-model="formParam.button_type"
                          class="form-check-input"
                          type="radio"
                          id="url"
                          value="url"
                        />
                        <label class="form-check-label" for="url">Link</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          Destination:
                          <span class="text-danger">*</span>
                        </label>
                        <!-- {{broadcastParam}} -->
                        <div class="message-bar">
                          <div class="message-inner">
                            <div class="message-area">
                              <div class="input-group m-b-30">
                                <div
                                  class="input-group-prepend"
                                  v-if="formParam.button_type=='url'"
                                >
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle text-info"
                                      data-toggle="dropdown"
                                      aria-expanded="false"
                                    >
                                      <i class="material-icons">more_vert</i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                      <span style="margin:5px;">
                                        <b>
                                          <u>Template Message:</u>
                                        </b>
                                      </span>
                                      <template v-for="temp in templateMessage">
                                        <a
                                          class="dropdown-item"
                                          @click.prevent="addTemplateToMesage(temp)"
                                          :key="temp"
                                        >{{temp}}</a>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="formParam.button_response"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <center v-if="isSending==false">
                    <!-- {{isSending}} -->
                    <button @click="saveForm(0)" class="btn btn-md btn-success" type="button">
                      <i class="fa fa-check"></i> Save
                    </button>
                    <button
                      @click.prevent="saveForm(1)"
                      class="btn btn-md btn-info"
                      type="button"
                      :style="'margin-left:10px;'"
                    >
                      <i class="fa fa-check"></i> Save &amp; Exit
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes,
  currentDateTimeUTC
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect,
    Datetime
  },
  props: {
    searchData: {
      type: Function
    }
  },
  data() {
    return {
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },
      templateMessage: [
        "${month_current}",
        "${month_current_name}",
        "${year_current}",
        "${today}",
        "${yesterday}",
        "${month_ago}",
        "${month_ago_name}",
        "${year_ago}"
      ],
      isSending: false,

      formParam: {
        id: "",
        button_type: "call",
        button_title: "",
        button_text: "",
        button_response: ""
      },
      isLoading: false
    };
  },
  watch: {
    isShowForm: {
      handler: function(val, oldVal) {
        // console.log("val", val, "oldVal", oldVal);
        if (val == true) {
          // this.selectedLicense = [];
          var that = this;
          setTimeout(function() {
            // console.log("that.broadcastParamSt", that.broadcastParamSt);
            if (
              that.formParamLinkSt.id != "" &&
              that.formParamLinkSt.id != null
            ) {
              that.formParam = that.formParamLinkSt;
            } else {
              that.formParam = {
                id: "",
                button_type: "call",
                button_title: "",
                button_text: "",
                button_response: ""
              };
            }
          }, 100);
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    formParamLinkSt() {
      return this.$store.state.automation.formParamLinkSt;
    },
    isShowForm() {
      return this.$store.state.automation.isShowForm;
    }
  },
  methods: {
    addTemplateToMesage(template) {
      this.formParam.button_response += template;
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },

    async saveForm(isExit = 0) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          // console.log("valueee", r);
          this.isSending = await true;
          this.emojiToggle(false);
          this.formParam.button_response = await this.remove_tags(
            this.formParam.button_response
          );
          await this.$store
            .dispatch("automation/storeReplyLink", this.formParam)
            .then(response => {
              // this.isSending = false;
              if (this.formParam.id == "") {
                this.formParam = {
                  id: "",
                  button_type: "call",
                  button_title: "",
                  button_text: "",
                  button_response: ""
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              }).then(r => {});
              this.searchData();
              if (isExit == 1) {
                var elem = this.$refs.dismisModal;
                elem.click();
              }
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.formParam.button_response += args.emoji;
      // console.log(args); /* return {...}*/
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/automation/replyLink/form.vue